export const SUCCESS = 'success';
export const WARNING = 'warning';
export const INFO = 'info';
export const ERROR = 'error';
export const VALID_SEVERITIES = [SUCCESS, WARNING, INFO, ERROR];
